export default __webpack_public_path__ + "static/media/Kaan-BG.48187360.webp";